export default "__VITE_ASSET__Bbdty$lw__"